export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  enableReduxDevTools: process.env.REACT_APP_ENABLE_REDUX_DEV_TOOLS === 'true',
  teamEmail: process.env.REACT_APP_TEAM_EMAIL,
};
